// extracted by mini-css-extract-plugin
module.exports = {"footer":"XRV54QDTvN7u","footer__price":"_5TefDrvJhD0T","price__from":"_3MYvQ5RgFEyZ","footer__button":"_1zcBycuwkIdG","footer_selected":"fP6S8EVpoVHg"};